// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapImage } from '../../../dsl/front';
/**
 * @author Sebastian Dziechciarz <sebastian.dziechciarz@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let ArticleAuthor = class ArticleAuthor extends Vue {
    constructor() {
        super(...arguments);
        /**
         * The present as `Date` object
         */
        this.now = new Date();
    }
    /**
     * Determines whether the article's publication date is newer than `this.now`.
     */
    get isFutureDate() {
        try {
            if (!this.publicationDate) {
                return true;
            }
            return new Date(this.publicationDate) > this.now;
        }
        catch (e) {
            console.warn(e);
            return false;
        }
    }
    /**
     * Article's publication time as `PublicationTime` enum.
     */
    get publicationTime() {
        if (typeof this.publicationDate !== 'string' || this.publicationDate.length === 0) {
            return '';
        }
        try {
            const date = new Date(this.publicationDate);
            const d = date.getDate().toString().padStart(2, '0');
            const m = (date.getMonth() + 1).toString().padStart(2, '0');
            const y = date.getFullYear().toString().padStart(2, '0');
            if (this.shortenDate) {
                return `${d}.${m}.${y}`;
            }
            else {
                const t = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
                return `${d}.${m}.${y} ${t}`;
            }
        }
        catch (e) {
            // In case if error occurs while formatting with format()
            const [date, time] = this.publicationDate.split('T');
            if (time) {
                return date.replace(/-/g, '.') + ' ' + (time.split(':')[0] + ':' + time.split(':')[1]);
            }
            else {
                return '';
            }
        }
    }
};
__decorate([
    Prop({ type: Object, required: false, default: () => ({}) })
], ArticleAuthor.prototype, "avatar", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "hideDate", void 0);
__decorate([
    Prop({ type: String, required: true })
], ArticleAuthor.prototype, "name", void 0);
__decorate([
    Prop({ type: String, required: false, default: null })
], ArticleAuthor.prototype, "publicationDate", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "shortenDate", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleAuthor.prototype, "showAuthorAvatar", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleAuthor.prototype, "showAuthorName", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ArticleAuthor.prototype, "showInitialsWhenNoAvatar", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true })
], ArticleAuthor.prototype, "showPublicationDate", void 0);
ArticleAuthor = __decorate([
    Component({
        name: 'ArticleAuthor',
        components: { BootstrapImage },
        template: `
    <div class="article-author">
    <!-- Avatar -->
    <BootstrapImage v-if="showAuthorAvatar && avatar && avatar.src && avatar.src.length"
                    v-bind="avatar" class="article-author__avatar img-avatar me-4"/>
    <div v-else-if="showInitialsWhenNoAvatar" class="article-author__initials mr-3">
      {{ name.split(' ')[0][0] }}{{ name.split(' ')[1][0] }}
    </div>

      <!-- Text data -->
      <p class="article-author__texts">
        <span v-if="showAuthorName && name && name.length"
              class="article-author__name text-ui-small text-uppercase">
          {{ name }}
        </span>
        <template v-if="!hideDate">
          <time v-if="showPublicationDate && publicationDate && publicationTime"
                :datetime="new Date(publicationDate).toISOString()" class="article-author__publication-time fs-small">
            {{ !isFutureDate ? publicationTime : $t('modules.tile.futureDate') }}
          </time>
        </template>
      </p>
    </div>
  `
    })
], ArticleAuthor);
export { ArticleAuthor };
